import React from 'react'

const ShoppingProgressSkeleton = () => {
  return (
    <div className="container">
      <div className="step-bar-section">
        <div className="row step-bar-section-row">
          <div className="col step-bar-repeat">
            <div className="step-bar-box step-first">
              <div className="column step-bar-number">
                <span>1</span>
              </div>
              <div className="first-step-arrow"></div>
            </div>
          </div>
          <div className="col step-bar-repeat">
            <div className="step-bar-box step-second">
              <div className="column step-bar-number">
                <span>2</span>
              </div>
              <div className="first-step-arrow"></div>
            </div>
          </div>
          <div className="col step-bar-repeat">
            <div className="step-bar-box step-third">
              <div className="column step-bar-number">
                <span>3</span>
              </div>
              <div className="first-step-arrow"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShoppingProgressSkeleton
